import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

import { FaPhoneAlt } from 'react-icons/fa';
import KomisiaImage from '../images/komisiebi.png';

import { useContext } from 'react';
import { SearchContext } from './Contexts/Context';
import { use } from 'react';
import { getFraqciaBySlug, getKomisiaBySlug } from '../service/service';
function SakrebuloFraqciebi1() {
	const { id } = useParams();
	const { language } = useContext(SearchContext);
	const [menu, setMenu] = useState({});
	const [komisia, setKomisia] = useState({});
	const [loading, setLoading] = useState(false);
	const [komisiaChairman, setKomisiaChairman] = useState([]);
	const [loadingChairman, setLoadingChairman] = useState(false);
	const [komisiaNotChairman, setKomisiaNotChairman] = useState([]);

	useEffect(() => {
		const link = 'https://khulo.gov.ge/api/site_menu1.php';
		fetch(link)
			.then(response => response.json())
			.then(data => {
				// console.log('data.menu',data.menu)
				setMenu(data.menu);

				//  console.log('menu', menu)

				//  console.log('object entries', Object.entries(menu))

				Object.entries(menu).map(item => {
					if (item[1].level == 1) {
						//console.log('entries item', item[1].name_eng , item[1].level)
					}
				});
			});
	}, []);
	const presscenterList = Object.entries(menu).length
		? Object.entries(menu).map((item, index) => {
				if (item[1].level == 1 && item[1].name_geo == 'საკრებულო') {
					return Object.entries(menu).map((qveItem, index) => {
						if (qveItem[1].parent_id == item[1].cat_id) {
							return (
								<span
									key={index}
									className={
										window.location.href.includes(qveItem[1].slug)
											? 'active'
											: ''
									}
								>
									<Link to={`/${qveItem[1].slug}`}>{qveItem[1].name_geo}</Link>
								</span>
							);
						}
					});
				}
		  })
		: 'LOADING';

	const [komisiaMembers, setKomisiaMembers] = useState([]);
	const [members, setMembers] = useState([]);
	const [tavmjdomare, setTAvmjdomare] = useState({});
	useEffect(() => {
		const link = `https://khulo.gov.ge/api/members.php?`;
		fetch(link)
			.then(response => response.json())
			.then(data => {
				data.map(item => {
					item.geo.comision.map(com => {
						if (com == id) {
							komisiaMembers.push(item);
							
						}
					});
				});

				data.map(item => {
					if (item.geo.chairman == id) {
						setTAvmjdomare(item);
					}
				});

				setMembers(data);
			});
	}, []);

	const tavmjdomareUI = Object.entries(tavmjdomare).length ? (
		<>
			<span>
				{language == 1 ? tavmjdomare.geo.title : tavmjdomare.eng.title}
			</span>
			<span>
				{language == 1 ? tavmjdomare.geo.chairman : tavmjdomare.eng.chairman}
			</span>
			<Helmet>
				<title>
					{language == 1 ? tavmjdomare.geo.chairman : tavmjdomare.eng.chairman}
				</title>
			</Helmet>
			<div className='half'>
				<span>{tavmjdomare.geo.email}</span>
				<span>
					<FaPhoneAlt /> {tavmjdomare.geo.mobile}
				</span>
			</div>
		</>
	) : (
		''
	);
	const ref = useRef(null);
	const [width, setWidth] = useState(10);
	useLayoutEffect(() => {
		setWidth(ref.current.offsetWidth);
	});

	const komisiaFC = async slug => {
		await getFraqciaBySlug(slug).then(data => {
			setKomisia(data);
			setLoading(true);
		});
	};

	const isChairman = async chairman => {
		if (loading === true) {
			await komisia.filter(item => {
				if (item.is_chairman !== chairman) {
					setKomisiaChairman(item);
					setLoadingChairman(true);
				}
			});
		}
		return null;
	};

	const notChairman = async () => {
		if (komisiaChairman.length === 0) {
			const filtered = komisia.filter(item => item.is_chairman === false);
			if (filtered.length > 0) {
				setKomisiaNotChairman(filtered);
				setLoadingChairman(true);
			}
		}
	};

	useEffect(() => {
		if (komisia.length !== 0) {
			isChairman(false);
			notChairman();
		}
	}, [komisia]);
	useEffect(() => {
		komisiaFC(id);
	}, [id]);

	const KomisiaView = () => {
		return loadingChairman ? (
			<>
				<span>
					{komisiaChairman?.member?.full_name + ' - ფრაქციის თავმჯდომარე'}
				</span>
				<span> {komisiaChairman?.fraqcia?.name}</span>
				<div className='half'>
					<span>
						{komisiaChairman?.member.email
							? komisiaChairman?.member.email
							: 'არ არის მითითებული'}
					</span>
					<span>
						<FaPhoneAlt />{' '}
						{komisiaChairman?.member.mobile
							? komisiaChairman?.member.mobile
							: 'არ არის მითითებული'}
					</span>
				</div>
			</>
		) : (
			<div>Loading...</div>
		);
	};



	return (
		<motion.div
			intial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className='news-container margin-280px'>
				<header>
					<span className='big' ref={ref} style={{ marginRight: width / 2 }}>
						{' '}
						{language == 1 ? 'საკრებულო' : 'KHULO CITY ASSEMBLY'}
					</span>
					<span>
						{language == 1 ? 'საკრებულოს ფრაქციები' : 'ASSEMBLY COMISSIONS'}
					</span>
				</header>
				<div>
					<div className='sakrebulo-landing'>
						<div className='landing-container'>
							<div className='komisia'>
								<div className=''>
									{loadingChairman ? (
										<>
											<KomisiaView />
											<header>
												{language == 1
													? 'საკრებულოს ფრაქციები წევრები'
													: 'COMISSION MEMBERS'}
											</header>
											{komisiaNotChairman?.map((item, index) => {
												return (
													<span key={index}>
														{item?.member?.full_name}
														{item?.is_deputy_chairman
															? ' - ფრაქციის მოადგილე'
															: ''}
													</span>
												);
											})}
										</>
									) : (
										'loading'
									)}

									{/*  */}
								</div>

								<div className=''>
									<img src={komisiaChairman?.fraqcia?.image} alt='komisiaimage' />
								</div>
							</div>
						</div>
					</div>
					<div className='presscenter-info'>{presscenterList}</div>
				</div>
			</div>
		</motion.div>
	);
}

export default SakrebuloFraqciebi1;
